import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { fullscreen } from 'shared/lib';
import { ActionIcon, Button } from 'shared/ui';
import FullscreenIcon from 'shared/ui/assets/icons/fullscreen-icon.svg?react';
import WindowedIcon from 'shared/ui/assets/icons/windowed-icon.svg?react';

export const SidebarFullscreenButton = () => {
	const { t } = useTranslation();
	const fs = useUnit(fullscreen);

	return (
		<Button
			variant='standard'
			leftSection={
				<ActionIcon
					variant='secondary'
					component='div'
				>
					{fs.active ? <WindowedIcon /> : <FullscreenIcon />}
				</ActionIcon>
			}
			onClick={fs.toggle}
		>
			{t('sidebar.fullscreen-button-label')}
		</Button>
	);
};
